















































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import EmployeeApi from '@/api/employee/index'
import PicModal from '@/components/upload/picModal.vue'
import ShopApi from '@/api/shopInfo/index'

@Component({
  components: {
    PicModal,
  },
})
export default class EditEmployee extends AbpBase {
  storeList: any[] = []
  form = {
    name: null,
    headImgUri: null,
    vipCode: null,
    phoneNumber: null,
    storeName: null,
    gender: null,
    birthDay: null,
    storeId: null,
    shopCode: null,
    position: null,
  }

  ruleForm = {
    name: [{ required: true, message: '请输入导购姓名', trigger: 'blur' }],
    vipCode: [{ required: true, message: '请输入工号', trigger: 'blur' }],
    position: [{ required: true, message: '请输入职位', trigger: 'blur' }],
    identityNumber: [
      {
        required: true,
        validator: this.validateIdentityNumber,
        trigger: 'blur',
      },
    ],
    // phoneNumber: [{ required: true, validator: this.validatePhoneNumber, trigger: 'blur' }],
    storeName: [{ required: true, message: '请输入所属门店', trigger: 'blur' }],
    birthDay: [{ type: 'date', required: true, message: '请选择出生日期', trigger: 'change' }],
    gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
  }

  validateIdentityNumber(rule, value, callback) {
    const reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
    if (!value) {
      callback(new Error('请输入身份证号'))
    } else if (value !== '' && !reg.test(value)) {
      callback(new Error('请填写正确的身份证号'))
    } else {
      callback()
    }
  }

  validatePhoneNumber(rule, value, callback) {
    const reg = /^[1][3-8]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/
    if (!value) {
      callback(new Error('请输入手机号'))
    } else if (value !== '' && !reg.test(value)) {
      callback(new Error('请填写正确的手机号'))
    } else {
      callback()
    }
  }

  get editState() {
    let id = this.$route.query['id']
    if (id) {
      return true
    }
    return false
  }

  created() {
    this.getEmployee()
    this.getStoreList()
  }
  selectStore(e) {
    console.log(e)
    let obj = this.storeList.find((item) => item.id == e)
    this.form.storeName = obj.displayName
    this.form.shopCode = obj.code
  }

  /**
   * 获取导购信息
   */
  getEmployee() {
    let id = this.$route.query['id']
    if (id) {
      ShopApi.getVipInfoById(id.toString()).then((res) => {
        this.form = res.data
      })
    }
  }

  picChange(e) {
    this.form.headImgUri = e[0].url
  }

  submit() {
    let vm = this
    let form: any = vm.$refs.form
    let id  = this.$route.query.id ? this.$route.query.id.toString() : ''
    console.log(vm.form)
    form.validate((valid) => {
      if (valid) {
        let obj = JSON.parse(JSON.stringify(vm.form))
        obj.gender = obj.gender == '0' ? 'true' : obj.gender == '1' ? 'false' : 'null'
        console.log('234234', id);
        ShopApi.createVipInfo(obj, id).then((res) => {
          vm.$Notice.success({
            desc: id ? '更新成功' : '创建成功',
          })
          vm.$router.push({
            name: 'guideList',
          })
        })
      }
    })
  }
  getStoreList() {
    ShopApi.getList2(999, 0, '').then((res) => {
      console.log('门店列表', res)
      this.storeList = res.data.items
    })
  }
}
